import { MessageKeys } from '../validators';
import i18next from 'i18next';

export const buildInitState = () => ({
  totalScore: null,
  byPriceScore: null,
  byQualityScore: null,
  bodyText: null,
  prosText: null,
  consText: null,
  recommended: null,
  authorTimeUsage: null,
  authorShop: null,
  authorName: null,
  authorEmail: null,
  fieldsErrors: [
    {
      fieldKey: 'rating',
      message: i18next.t(MessageKeys.DO_TOTAL_SCORE),
      errorKey: 'required-fields-are-missing',
    },
    {
      fieldKey: 'body',
      message: i18next.t(MessageKeys.LEAVE_TEXT_CONTENT),
      errorKey: 'required-fields-are-missing',
    },
    {
      fieldKey: 'author_name',
      message: i18next.t(MessageKeys.NEED_DATA_FOR_ANSWER),
      errorKey: 'required-fields-are-missing',
    },
    {
      fieldKey: 'author_email',
      message: i18next.t(MessageKeys.NEED_DATA_FOR_ANSWER),
      errorKey: 'required-fields-are-missing',
    },
  ],
  requiredFieldsAreEmpty: true,
});
